import { GlButton, GlPopover, GlSprintf, GlLink, GlDisclosureDropdown, GlTooltipDirective } from '@gitlab/ui';
import { BV_HIDE_TOOLTIP, BV_SHOW_TOOLTIP } from '~/lib/utils/constants';
export default {
    name: 'ActionButtons',
    components: {
        GlButton,
        GlPopover,
        GlSprintf,
        GlLink,
        GlDisclosureDropdown
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        tertiaryButtons: {
            type: Array,
            // fix `spec/frontend/vue_merge_request_widget/mr_widget_options_spec.js` before making this required
            required: false,
            default: ()=>[]
        }
    },
    emits: [
        'clicked-action'
    ],
    data: ()=>{
        return {
            timeout: null,
            updatingTooltip: false
        };
    },
    computed: {
        hasOneOption () {
            return this.tertiaryButtons.length === 1;
        },
        hasMultipleOptions () {
            return this.tertiaryButtons.length > 1;
        },
        dropdownItems () {
            return this.tertiaryButtons.map((item)=>{
                return {
                    ...item,
                    text: item.text,
                    href: item.href,
                    extraAttrs: {
                        dataClipboardText: item.dataClipboardText,
                        dataMethod: item.dataMethod,
                        target: item.target
                    }
                };
            });
        }
    },
    methods: {
        onClickAction (action) {
            this.$emit('clicked-action', action);
            if (action.onClick) {
                action.onClick();
            }
            if (action.tooltipOnClick) {
                this.updatingTooltip = true;
                this.$root.$emit(BV_SHOW_TOOLTIP, action.id);
                clearTimeout(this.timeout);
                this.timeout = setTimeout(()=>{
                    this.updatingTooltip = false;
                    this.$root.$emit(BV_HIDE_TOOLTIP, action.id);
                }, 1000);
            }
        },
        setTooltip (btn) {
            if (this.updatingTooltip && btn.tooltipOnClick) {
                return btn.tooltipOnClick;
            }
            return btn.tooltipText;
        }
    }
};
